import VehiclesEdition from './VehiclesEdition';

export default VehiclesEdition;
